import { render, staticRenderFns } from "./Salestaff.vue?vue&type=template&id=4ad3f714&scoped=true&"
import script from "./Salestaff.vue?vue&type=script&lang=js&"
export * from "./Salestaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad3f714",
  null
  
)

export default component.exports